export default __webpack_public_path__ + "static/media/51-min.921029d2.png";